import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/corner-down-right_16.svg.ts
import { svg } from "lit";
var cornerDownRight16Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10 7L13 10L10 13" stroke="#1F1F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3 3V7.33334C3 8.04058 3.28095 8.71886 3.78105 9.21896C4.28115 9.71905 4.95942 10 5.66667 10H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export {
  cornerDownRight16Svg
};
//# sourceMappingURL=corner-down-right_16.svg-YYSNWS3X.js.map
